import { render, staticRenderFns } from "./iconP1.vue?vue&type=template&id=6e0cd7bc&scoped=true&"
import script from "./iconP1.vue?vue&type=script&lang=js&"
export * from "./iconP1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0cd7bc",
  null
  
)

export default component.exports